(function() {
  'use strict';

  var ZXING_URL = 'https://unpkg.com/@zxing/library@0.21.3/umd/index.min.js';
  var barcodeFormats = [
    'aztec',
    'codabar',
    'code_39',
    'code_93',
    'code_128',
    'data_matrix',
    'ean_8',
    'ean_13',
    'itf',
    'pdf417',
    'qr_code',
    'upc_a',
    'upc_e'
  ];
  var zxingLoader = null;
  var activeSession = null;

  function getSession(form) {
    if (!form) return null;

    var scanner = form.querySelector('[data-mm-search-scanner]');
    if (!scanner) return null;

    return {
      active: false,
      detectorBusy: false,
      form: form,
      input: form.querySelector('[data-mm-search-input], input[name="q"]'),
      manual: scanner.querySelector('[data-mm-scan-manual]'),
      originalNextSibling: null,
      originalParent: null,
      scanner: scanner,
      status: scanner.querySelector('[data-mm-scan-status]'),
      stream: null,
      video: scanner.querySelector('[data-mm-scan-video]'),
      zxingReader: null
    };
  }

  function mountScanner(session) {
    if (!session || !session.scanner || !document.body) return;
    if (session.scanner.parentNode === document.body) return;

    session.originalParent = session.scanner.parentNode;
    session.originalNextSibling = session.scanner.nextSibling;
    document.body.appendChild(session.scanner);
  }

  function restoreScanner(session) {
    if (!session || !session.scanner || !session.originalParent) return;

    if (session.originalNextSibling && session.originalNextSibling.parentNode === session.originalParent) {
      session.originalParent.insertBefore(session.scanner, session.originalNextSibling);
    } else {
      session.originalParent.appendChild(session.scanner);
    }

    session.originalParent = null;
    session.originalNextSibling = null;
  }

  function setStatus(session, message) {
    if (session && session.status) session.status.textContent = message;
  }

  function stopSession(session) {
    if (!session) return;
    session.active = false;

    if (session.zxingReader && typeof session.zxingReader.reset === 'function') {
      session.zxingReader.reset();
    }

    if (session.stream) {
      session.stream.getTracks().forEach(function(track) {
        track.stop();
      });
    }

    if (session.video) {
      session.video.pause();
      session.video.removeAttribute('src');
      session.video.srcObject = null;
      session.video.load();
    }

    session.stream = null;
    session.zxingReader = null;
  }

  function closeScanner(session) {
    var closingSession = session || activeSession;
    stopSession(closingSession);

    if (closingSession && closingSession.scanner) {
      closingSession.scanner.hidden = true;
      restoreScanner(closingSession);
    }

    if (activeSession && activeSession !== closingSession && activeSession.scanner) {
      activeSession.scanner.hidden = true;
      restoreScanner(activeSession);
    }

    document.documentElement.classList.remove('mm-search-scanner-open');
    activeSession = null;
  }

  function submitCode(session, rawCode) {
    var code = String(rawCode || '').trim();
    if (!code || !session || !session.form || !session.input) return;

    closeScanner(session);

    try {
      var scannedUrl = new URL(code);
      if (scannedUrl.origin === window.location.origin) {
        window.location.href = scannedUrl.href;
        return;
      }
    } catch (error) {
      // Not a URL, keep searching by scanned product code.
    }

    session.input.value = code;
    session.input.dispatchEvent(new Event('input', { bubbles: true }));
    session.input.dispatchEvent(new Event('change', { bubbles: true }));

    if (typeof session.form.requestSubmit === 'function') {
      session.form.requestSubmit();
    } else {
      session.form.submit();
    }
  }

  function loadZxing() {
    if (window.ZXing && window.ZXing.BrowserMultiFormatReader) {
      return Promise.resolve(window.ZXing);
    }

    if (zxingLoader) return zxingLoader;

    zxingLoader = new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = ZXING_URL;
      script.async = true;
      script.onload = function() {
        if (window.ZXing && window.ZXing.BrowserMultiFormatReader) {
          resolve(window.ZXing);
        } else {
          reject(new Error('ZXing scanner unavailable'));
        }
      };
      script.onerror = function() {
        reject(new Error('Scanner library could not load'));
      };
      document.head.appendChild(script);
    });

    return zxingLoader;
  }

  function cameraOptions() {
    return {
      audio: false,
      video: {
        facingMode: { ideal: 'environment' },
        height: { ideal: 720 },
        width: { ideal: 1280 }
      }
    };
  }

  function getSupportedNativeFormats() {
    if (!('BarcodeDetector' in window)) return Promise.resolve([]);

    if (typeof window.BarcodeDetector.getSupportedFormats !== 'function') {
      return Promise.resolve(barcodeFormats);
    }

    return window.BarcodeDetector.getSupportedFormats().then(function(supportedFormats) {
      return barcodeFormats.filter(function(format) {
        return supportedFormats.indexOf(format) !== -1;
      });
    });
  }

  function scanNativeFrame(session, detector) {
    if (!session.active || !session.video) return;

    if (session.video.readyState >= 2 && !session.detectorBusy) {
      session.detectorBusy = true;
      detector.detect(session.video)
        .then(function(results) {
          if (!session.active) return;
          if (results && results.length && results[0].rawValue) {
            submitCode(session, results[0].rawValue);
          }
        })
        .catch(function() {
          setStatus(session, 'Code frame me rakhein, scan automatic hoga.');
        })
        .finally(function() {
          session.detectorBusy = false;
        });
    }

    window.setTimeout(function() {
      window.requestAnimationFrame(function() {
        scanNativeFrame(session, detector);
      });
    }, 120);
  }

  function startNativeScanner(session) {
    return getSupportedNativeFormats().then(function(formats) {
      if (!formats.length) throw new Error('Native scanner unsupported');

      var detector = new window.BarcodeDetector({ formats: formats });
      return navigator.mediaDevices.getUserMedia(cameraOptions()).then(function(stream) {
        session.stream = stream;
        session.video.srcObject = stream;
        return session.video.play().then(function() {
          setStatus(session, 'Barcode ya QR code ko frame ke andar rakhein.');
          scanNativeFrame(session, detector);
        });
      });
    });
  }

  function startZxingScanner(session) {
    return loadZxing().then(function(ZXing) {
      var reader = new ZXing.BrowserMultiFormatReader();
      session.zxingReader = reader;
      setStatus(session, 'Camera open ho raha hai...');
      return reader.decodeFromVideoDevice(null, session.video, function(result) {
        if (result && session.active) {
          var code = typeof result.getText === 'function' ? result.getText() : result.text;
          submitCode(session, code);
        }
      }).then(function() {
        setStatus(session, 'Barcode ya QR code ko frame ke andar rakhein.');
      });
    });
  }

  function startScanner(session) {
    if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
      setStatus(session, 'Camera scanner supported nahi hai. Code type karke search karein.');
      return;
    }

    session.active = true;
    setStatus(session, 'Camera permission allow karein...');

    startNativeScanner(session).catch(function(nativeError) {
      if (nativeError && nativeError.name === 'NotAllowedError') {
        setStatus(session, 'Camera permission nahi mili. Code type karke search karein.');
        return;
      }

      startZxingScanner(session).catch(function() {
        setStatus(session, 'Scanner is browser me supported nahi hai. Code type karke search karein.');
      });
    });
  }

  function openScanner(form) {
    var session = getSession(form);
    if (!session) return;

    if (activeSession) closeScanner(activeSession);
    activeSession = session;
    mountScanner(session);
    session.scanner.hidden = false;
    document.documentElement.classList.add('mm-search-scanner-open');

    if (session.manual) {
      session.manual.value = session.input ? session.input.value : '';
    }

    startScanner(session);
  }

  document.addEventListener('click', function(event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var scanButton = event.target.closest('[data-mm-search-scan]');
    var closeButton = event.target.closest('[data-mm-scan-close]');
    var submitButton = event.target.closest('[data-mm-scan-submit]');

    if (scanButton) {
      event.preventDefault();
      openScanner(scanButton.closest('[data-mm-search-form]'));
      return;
    }

    if (closeButton) {
      event.preventDefault();
      closeScanner(activeSession);
      return;
    }

    if (submitButton) {
      event.preventDefault();
      var form = submitButton.closest('[data-mm-search-form]');
      var session = activeSession || getSession(form);
      if (session && session.manual) {
        submitCode(session, session.manual.value);
      }
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && activeSession) {
      closeScanner(activeSession);
      return;
    }

    if (event.key === 'Enter' && activeSession && event.target.matches('[data-mm-scan-manual]')) {
      event.preventDefault();
      submitCode(activeSession, event.target.value);
    }
  });

  document.addEventListener('visibilitychange', function() {
    if (document.hidden && activeSession) {
      closeScanner(activeSession);
    }
  });
})();
